var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"list"},[_c('div',{staticClass:"list-item",on:{"click":_vm.verifyWithMask}},[_vm._v("人脸实名验证")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }